import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { RiCoinsFill } from 'react-icons/ri';

interface CardPointsEarnedProps {
    points: number;
    className?: string;
}

const CardPointsEarned = ({ points, className = '' }: CardPointsEarnedProps) => {
    const { t } = useTranslation();
    const { company } = useLayoutContext();

    if (!points || points <= 0) return null;

    const currencyName = company?.fidelity?.currency_name || 'Pontos';

    return (
        <div className={`flex flex-col items-center justify-center bg-custom-primary text-white rounded-xl p-4 w-fit animate-in zoom-in ${className}`}>

            <h6 className="font-bold text-xl w-full text-center leading-none uppercas">{t('cart.fidelity.you_earned', 'Você ganhou')}</h6>

            <div className="flex items-center gap-0 w-full justify-center">
                <RiCoinsFill className="text-white text-3xl" />
                <span className="font-black leading-none text-4xl">{points}</span>
                <span className="text-2xl font-black ml-1.5">{currencyName}</span>
            </div>

            <span className="opacity-80 w-full text-center text-sm leading-none">
                {t('cart.fidelity.with_this_purchase', 'com essa compra')}
            </span>
            {/* <div className="max-w-40 text-xs opacity-40 text-center mt-1">No nosso programa de fidelidade</div> */}
        </div>
    );
};

export default CardPointsEarned;
